export enum ContractStatusEnum {
  InProgess = 1,
  DocumentationSent = 2,
  Current = 3,
  TerminatedAgreement = 6,
  Finished = 7,
  Renewed = 9,
  Canceled = 10
}